const BASE_URL = 'https://vidsrc.to/embed';

/**
 * Gera a URL de embed para filmes ou episódios de séries
 * @param {string} type - 'movie' ou 'tv'
 * @param {string|number} id - ID do TMDB ou IMDB
 * @param {number} [season] - Número da temporada (para séries)
 * @param {number} [episode] - Número do episódio (para séries)
 */
export const getStreamUrl = (type, id, season = 1, episode = 1) => {
  if (type === 'movie') {
    return `${BASE_URL}/movie/${id}`; // Estrutura para filmes
  }
  return `${BASE_URL}/tv/${id}/${season}/${episode}`; // Estrutura para episódios
};
